import { useNavigate } from "react-router-dom";
import { QrCode, Store, Truck, ShoppingBag, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

function PageHero({ label, title, subtitle }) {
  return (
    <section className="bg-cream">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-20">
        <span className="text-xs uppercase tracking-[0.2em] font-semibold text-orange">{label}</span>
        <h1 className="mt-3 text-4xl lg:text-5xl font-extrabold text-navy tracking-tight max-w-3xl">{title}</h1>
        {subtitle && <p className="mt-4 text-lg text-navy/70 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}

export default function ComeFunziona() {
  const navigate = useNavigate();
  const steps = [
    { icon: Store, title: "Registrazione dei partner", desc: "B&B, bar e pasticcerie si registrano e vengono approvati da MorningBox nella loro zona." },
    { icon: CheckCircle2, title: "Collegamento tra partner", desc: "Il B&B sceglie i locali convenzionati della stessa città e invia una richiesta di convenzione." },
    { icon: ShoppingBag, title: "Creazione dell'ordine", desc: "L'ordine può essere creato dal B&B dal proprio pannello oppure dall'ospite tramite QR code." },
    { icon: Truck, title: "Ritiro o consegna", desc: "Il bar prepara la colazione, disponibile per il ritiro al bar o la consegna in camera." },
  ];
  return (
    <div>
      <PageHero label="Come funziona" title="Colazioni di qualità, gestite senza pensieri"
        subtitle="MorningBox collega le strutture ricettive con i migliori bar e pasticcerie della zona. Ecco come funziona il servizio." />
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 gap-5">
          {steps.map((s, i) => (
            <div key={i} className="bg-white border border-navy/10 rounded-2xl p-8 hover:shadow-md transition-shadow flex gap-5">
              <div className="w-14 h-14 rounded-2xl bg-navy flex items-center justify-center shrink-0">
                <s.icon className="w-7 h-7 text-orange" />
              </div>
              <div>
                <span className="text-sm font-bold text-orange">0{i + 1}</span>
                <p className="font-semibold text-navy text-lg mt-1">{s.title}</p>
                <p className="text-sm text-navy/60 mt-2 leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-12 bg-cream rounded-3xl p-8 lg:p-12 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1">
            <h2 className="text-2xl lg:text-3xl font-bold text-navy">Due modalità di acquisto</h2>
            <ul className="mt-5 space-y-3 text-navy/70">
              <li className="flex gap-3"><CheckCircle2 className="w-5 h-5 text-orange shrink-0 mt-0.5" /><span><b className="text-navy">Colazione inclusa:</b> il B&B sceglie locale e pacchetto e crea l'ordine dal proprio pannello.</span></li>
              <li className="flex gap-3"><CheckCircle2 className="w-5 h-5 text-orange shrink-0 mt-0.5" /><span><b className="text-navy">Camera senza colazione:</b> l'ospite scansiona il QR code e ordina in autonomia.</span></li>
            </ul>
          </div>
          <div className="w-40 h-40 rounded-2xl bg-white flex items-center justify-center brand-shadow">
            <QrCode className="w-20 h-20 text-navy" />
          </div>
        </div>
        <div className="mt-12 flex flex-wrap gap-3">
          <Button onClick={() => navigate("/registra/bnb")} className="rounded-full bg-navy text-white h-12 px-6">Registra la tua struttura</Button>
          <Button onClick={() => navigate("/registra/locale")} variant="outline" className="rounded-full h-12 px-6">Registra il tuo locale</Button>
        </div>
      </section>
    </div>
  );
}
